module.exports = __webpack_public_path__ + "img/leftside_1000.ede6f2b1.jpg";